export class CompanyLock {
  UserId: string;
  LegacyUserId: string;
  Description: string;
  LockType: number;
  CreatedOn: Date;
}

export enum LockTypes {
  'None' = 0,
  'Payroll' = 1,
  'NOT USED' = 2,
  'Payroll Held' = 3,
  'Manual Checks' = 4,
  'Client' = 5,
  'Manual Checks on Hold' = 6
}
